/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {StepProps} from '../IAppModels'
import {IPatientData} from '../../../interface/IPatientData'
import {KTIcon} from '../../../../../_metronic/helpers'
import CustomCalendar from '../../../../../_metronic/layout/calendar'

const Step2 = ({
  data,
  updateData,
  hasError,
  handleStep2ValidationSuccess,
  handleStep2ValidationError,
  errorMessageProduct,
  errorMessageBenefit,
}: StepProps) => {
  const [benefits, setBenefits] = useState<IPatientData['benefits']>([])
  const [selectedBenefit, setSelectedBenefit] = useState<IPatientData['benefits'][0] | null>(null)
  const [hasOpenedDropdown, setHasOpenedDropdown] = useState(false)

  // Validation states
  const [isPlanValid, setIsPlanValid] = useState(false)
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false)
  const [isMedicalRecordValid, setIsMedicalRecordValid] = useState(false)
  const [isReferralSourceValid, setIsReferralSourceValid] = useState(false)
  const [isNotesValid, setIsNotesValid] = useState(true)
  const [isBenefitsValid, setIsBenefitsValid] = useState(false)
  const [isTreatmentTypeValid, setIsTreatmentTypeValid] = useState(true)
  const [isIndateValid, setIsIndateValid] = useState(true)

  useEffect(() => {
    if (data.appBasic.memberData && data.appBasic.memberData.benefits) {
      setBenefits(data.appBasic.memberData.benefits)
    }

    // Initialize treatment type to 'Rawat inap' by default if not already set
    if (!data.appBasic.treatmentType) {
      updateData({
        appBasic: {
          ...data.appBasic,
          treatmentType: 'Rawat inap',
        },
      })
      setIsTreatmentTypeValid(true)
    }

    // Set current date for indate if treatment type is 'Rawat jalan'
    if (data.appBasic.treatmentType === 'Rawat jalan') {
      const currentDate = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD
      updateData({
        appBasic: {
          ...data.appBasic,
          indate: currentDate,
        },
      })
    }
  }, [data.appBasic.memberData, data.appBasic.treatmentType])

  console.log('data.appBasic.memberData', data.appBasic.memberData)

  const handleBenefitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const benefitId = e.target.value

    // Check if the selected value is not the default placeholder
    if (benefitId) {
      const selected = benefits.find((benefit) => benefit.id === parseInt(benefitId))
      setSelectedBenefit(selected || null)

      // Check if the selected benefit allows both treatment types or only outpatient
      const allowsBothTreatmentTypes =
        selected &&
        ['INPATIENT', 'INPATIENT-OUTPATIENT-KHUSUS', 'MATERNITY', 'LIMIT BOOSTER TAHUNAN'].includes(
          selected.benefitName
        )

      // If benefit doesn't allow both treatment types, force set to Rawat jalan
      const treatmentType = allowsBothTreatmentTypes
        ? data.appBasic.treatmentType || 'Rawat inap'
        : 'Rawat jalan'

      console.log('treatmentType', treatmentType)

      updateData({
        appBasic: {
          ...data.appBasic,
          benefitDetail: selected || null,
          benefit: selected ? selected.benefitName : '',
          plan: selected ? selected.planName : '',
          treatmentType: treatmentType,
        },
      })

      // Validate fields after selection
      validateFields({
        ...data.appBasic,
        benefitDetail: selected || null,
        benefit: selected ? selected.benefitName : '',
        plan: selected ? selected.planName : '',
        treatmentType: treatmentType,
      })
    } else {
      // Reset selectedBenefit if the default option is selected
      setSelectedBenefit(null)
      updateData({
        appBasic: {
          ...data.appBasic,
          benefitDetail: null,
          benefit: '',
          plan: '',
        },
      })
    }
  }

  const handleDropdownOpen = () => {
    setHasOpenedDropdown(true)
  }

  const validateFields = (appBasicData: typeof data.appBasic) => {
    const planValid = !!appBasicData.plan
    const phoneNumberValid = appBasicData.phoneNumber.trim() !== ''
    const benefitsValid = !!selectedBenefit
    const treatmentTypeValid = !!appBasicData.treatmentType

    // Make indate validation conditional on treatment type
    // Only required for "Rawat inap", always valid for "Rawat jalan"
    const indateValid =
      appBasicData.treatmentType === 'Rawat jalan'
        ? true
        : !!(appBasicData.indate && appBasicData.indate.trim() !== '')

    setIsPlanValid(planValid)
    setIsPhoneNumberValid(phoneNumberValid)
    setIsBenefitsValid(benefitsValid)
    setIsTreatmentTypeValid(treatmentTypeValid)
    setIsIndateValid(indateValid)

    // Include indate validation in overall validity check when needed
    const allFieldsValid =
      planValid && phoneNumberValid && benefitsValid && treatmentTypeValid && indateValid

    if (allFieldsValid) {
      handleStep2ValidationSuccess && handleStep2ValidationSuccess()
      console.log('Complete')
    } else {
      handleStep2ValidationError && handleStep2ValidationError()
      console.log('Incomplete')
    }
  }

  const handleInputChange = (field: string, value: string) => {
    // Special handling for treatment type
    if (field === 'treatmentType') {
      const updatedData = {
        appBasic: {
          ...data.appBasic,
          [field]: value,
        },
      }

      // If switching to "Rawat inap", reset the indate value
      if (value === 'Rawat inap') {
        updatedData.appBasic.indate = '' // Reset indate when Rawat inap is selected
      }
      // If switching to "Rawat jalan", set indate to current date
      else if (value === 'Rawat jalan') {
        const currentDate = new Date().toISOString().split('T')[0] // Format: YYYY-MM-DD
        updatedData.appBasic.indate = currentDate
      }

      updateData(updatedData)
      validateFields(updatedData.appBasic)
    }
    // Regular field handling for other fields
    else {
      const updatedData = {
        appBasic: {
          ...data.appBasic,
          [field]: value,
        },
      }

      updateData(updatedData)
      validateFields(updatedData.appBasic)
    }
  }

  return (
    <div className='pb-5 step-2' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* Indate Input */}

        {/* Begin::Form Group for Manfaat */}

        {/* End::Form Group */}

        {/* Begin::Form Group for Treatment Type */}

        {/* End::Form Group */}

        {/* Begin::Form Group for Plan Peserta */}

        {/* End::Form Group */}

        {/* Begin::Form Group for No. Telp. Pasien/Pendamping */}
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>No. Telp. Pasien/Pendamping</span>
            <span style={{color: '#059BB6'}}> *</span>
          </label>
          <input
            type='text'
            className={`form-control form-control-lg ${!isPhoneNumberValid ? 'is-invalid' : ''}`}
            placeholder='0812...'
            value={data.appBasic.phoneNumber}
            onChange={(e) => {
              const value = e.target.value
              const numericValue = value.replace(/[^0-9]/g, '')
              handleInputChange('phoneNumber', numericValue)
              setIsPhoneNumberValid(numericValue.trim() !== '')
            }}
          />
          {/* {!isPhoneNumberValid && <div className="invalid-feedback">No. Telp. Pasien/Pendamping wajib diisi.</div>} */}
        </div>
        {/* End::Form Group */}

        {/* Begin::Form Group for No. Rekam Medis */}
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>No. Rekam Medis</span>
            {/* <span style={{ color: '#059BB6' }}> *</span> */}
          </label>
          <input
            type='text'
            // className={`form-control form-control-lg form-control-solid ${!isMedicalRecordValid ? 'is-invalid' : ''}`}
            className={`form-control form-control-lg `}
            value={data.appBasic.medicalRecordNumber}
            onChange={(e) => {
              const value = e.target.value
              handleInputChange('medicalRecordNumber', value)
              setIsMedicalRecordValid(value.trim() !== '')
            }}
          />
          {/* {!isMedicalRecordValid && <div className="invalid-feedback">Medical record number is required.</div>} */}
        </div>
        {/* End::Form Group */}

        {/* Begin::Form Group for Asal Rujukan */}
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Asal Rujukan</span>
            {/* <span style={{ color: '#059BB6' }}> *</span> */}
          </label>
          <input
            type='text'
            // className={`form-control form-control-lg form-control-solid ${!isReferralSourceValid ? 'is-invalid' : ''}`}
            className={`form-control form-control-lg `}
            placeholder=''
            value={data.appBasic.referralSource}
            onChange={(e) => {
              const value = e.target.value
              handleInputChange('referralSource', value)
              setIsReferralSourceValid(value.trim() !== '')
            }}
          />
          {/* {!isReferralSourceValid && <div className="invalid-feedback">Asal Rujukan wajib diisi.</div>} */}
        </div>
        {/* End::Form Group */}

        {/* Begin::Form Group for Catatan */}
        <div className='fv-row mb-10'>
          <label
            className='d-flex align-items-center fs-5 fw-semibold mb-2'
            style={{color: '#6E7191'}}
          >
            <span className='ms-2'>Catatan</span>
            {/* <span style={{ color: '#059BB6' }}> *</span> */}
          </label>
          <textarea
            // className={`form-control form-control-lg form-control-solid ${!isNotesValid ? 'is-invalid' : ''}`}
            className={`form-control form-control-lg`}
            rows={3}
            value={data.appBasic.notes}
            onChange={(e) => {
              const value = e.target.value
              handleInputChange('notes', value)
              setIsNotesValid(value.trim() !== '')
            }}
          />
          {/* {!isNotesValid && <div className="invalid-feedback">Catatan wajib diisi.</div>} */}
        </div>
        {/* End::Form Group */}
      </div>
    </div>
  )
}

export {Step2}
